import React from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';
import bgTradingEvent from 'assets/img/bg_trading_event_sm.png';
import icLight from 'assets/svg/ic_light.svg';
import icArrow from 'assets/svg/ic_arrow_right_black.svg';
import bgThg from 'assets/img/bg_double_thg.png';
import Touchable from 'src/Components/Touchable';
import { navigateTradingEvent } from 'src/utils/navigate';

const TradingEventAds = ({
  className,
  hasEvent
}) => {
  const renderInfoEvent = () => /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.container, className)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.top
  }, /*#__PURE__*/React.createElement("img", {
    src: bgTradingEvent,
    className: styles.bg
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.wrapText
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.txtTitle
  }, "HERO TRADING EVENT IS"), /*#__PURE__*/React.createElement("div", {
    className: styles.badge
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.dot
  }), /*#__PURE__*/React.createElement("span", null, "Live")))), /*#__PURE__*/React.createElement("div", {
    className: styles.footer
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, /*#__PURE__*/React.createElement("img", {
    src: icLight,
    className: styles.light
  }), /*#__PURE__*/React.createElement("span", {
    className: styles.txtLabel
  }, "Tip:"), /*#__PURE__*/React.createElement("span", {
    className: styles.desc
  }, "Trades on event's heroes are usually FASTER due to high demand")), /*#__PURE__*/React.createElement(Touchable, {
    onClick: () => navigateTradingEvent(),
    className: styles.btn
  }, /*#__PURE__*/React.createElement("span", null, "Explore now"), /*#__PURE__*/React.createElement("img", {
    src: icArrow,
    className: styles.icArrow
  }))));

  const renderInEvent = () => /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.containerInEvent, className)
  }, /*#__PURE__*/React.createElement("img", {
    src: bgThg,
    className: styles.bg
  }), /*#__PURE__*/React.createElement("span", {
    className: styles.txtTitle
  }, "Trade volume added to your progress on the Hero trading event!"), /*#__PURE__*/React.createElement(Touchable, {
    onClick: () => navigateTradingEvent(),
    className: styles.btn
  }, /*#__PURE__*/React.createElement("span", null, "Explore now"), /*#__PURE__*/React.createElement("img", {
    src: icArrow,
    className: styles.icArrow
  })));

  return hasEvent ? renderInEvent() : renderInfoEvent();
};

export default TradingEventAds;